<div class="flex items-center justify-center dialog-header ">
    Move Lead To Group

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">

    <div>
        <div class="mb-1">
            <label for="leadSpaceSelect">Select Lead Group Name</label>
        </div>
        <p-select id="leadSpaceSelect" appendTo="body" class="w-full" [(ngModel)]="selectedLeadSpace"
            [options]="leadSpaceList">
        </p-select>
    </div>

    <div class="flex justify-end gap-4 mt-7">
        <p-button [label]="'Cancel'" variant="outlined" severity="danger" (click)="handleCloseDialog()"></p-button>
        <p-button [label]="'Move'" [icon]="'pi pi-arrow-right'" (click)="handleMoveLead()"
            [loading]="isLoading"></p-button>

    </div>

</div>